import React from 'react';
import {
  bool,
  func,
  number,
  oneOfType,
  shape,
  string
} from 'prop-types';
import { Calculator } from '@thd-olt-component-react/calculator';
import { BuyboxTooltip } from './BuyboxTooltip/BuyboxTooltip';
import * as calculatorHelper from '../BuyboxCalcHelper';
import { SUBCLASSWALLPAPER } from '../../constants';
import '../buybox.scss';

const BuyboxCalculator = ({
  showTooltip,
  addAdditional,
  itemId,
  quantity,
  pricing,
  info,
  fulfillment,
  installServices,
  onChangeCalculator,
  updateAdditionalQuantity
}) => {

  const calculatorProps = calculatorHelper.getCalculatorProps({
    fulfillment,
    installServices,
    info
  });
  if (!calculatorProps || !calculatorProps?.unitsPerCase) {
    return null;
  }
  const {
    calculatorType,
    lineItemName,
    dimensionNames,
    uom,
    uomPlural,
    caseUnitOfMeasure,
    productCategory,
    unitsPerCase
  } = calculatorProps || {};
  const wallpaperCalc = info?.subClassNumber === SUBCLASSWALLPAPER;
  return (
    <>
      <Calculator
        calculatorType={calculatorType}
        lineItemName={lineItemName}
        dimensionNames={dimensionNames}
        productCategory={productCategory}
        unitsPerCase={unitsPerCase}
        addAdditional={addAdditional}
        maxAreaNumber={wallpaperCalc ? 8 : 3}
        onCalculate={onChangeCalculator}
        itemId={itemId}
        hideMeasuringTips
      />
      {showTooltip && (
        <div className="tooltip__actions">
          <BuyboxTooltip
            uom={uom}
            uomPlural={uomPlural}
            unitsPerCase={unitsPerCase}
            caseUnitOfMeasure={caseUnitOfMeasure}
            addAdditional={addAdditional}
            quantity={quantity}
            pricing={pricing}
            onChange={updateAdditionalQuantity}
          />
        </div>
      )}
    </>
  );
};

BuyboxCalculator.propTypes = {
  showTooltip: bool,
  addAdditional: bool,
  itemId: string,
  quantity: oneOfType([string, number]),
  pricing: shape({
    bulkPrice: number,
    bulkPriceThresholdQty: number,
    originalPrice: number,
    specialPrice: number
  }),
  info: shape({
    subClassNumber: string,
    projectCalculatorEligible: bool,
    calculatorType: string,
    pipCalculator: shape({
      toggle: string,
      coverageUnits: string,
      display: bool,
      publisher: number
    })
  }),
  fulfillment: shape({
    backordered: bool
  }),
  installServices: shape({
    scheduleAMeasure: bool
  }),
  onChangeCalculator: func,
  updateAdditionalQuantity: func
};

BuyboxCalculator.defaultProps = {
  showTooltip: false,
  addAdditional: true,
  itemId: null,
  quantity: 1,
  pricing: {},
  info: null,
  fulfillment: null,
  installServices: null,
  onChangeCalculator: () => {},
  updateAdditionalQuantity: () => {}
};

export { BuyboxCalculator };
